import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { convertFromRaw } from '@wix/communities-blog-rce';
import { updateComment } from '../../actions/update-comment';
import { stopEditingComment } from '../../actions/stop-editing-comment';
import CommentFormWrapper from '../../components/comment-form-wrapper';
import messages, { COMMENT_UPDATE } from '../../components/message/messages';
import CommentForm from '../../components/comment-form';
import withEnvironment from '../../hoc/with-environment';

export class CommentEditForm extends Component {
  handleSubmit = values => {
    const { comment, updateComment, showMessage } = this.props;
    updateComment({ ...comment, ...values }).then(() =>
      showMessage(messages[COMMENT_UPDATE].content(), messages[COMMENT_UPDATE].type),
    );
  };

  render = () => {
    const { stopEditingComment, comment } = this.props;
    return (
      <CommentFormWrapper>
        <CommentForm
          initialValues={{ content: convertFromRaw(comment.content), ownerId: comment.ownerId }}
          onSubmit={this.handleSubmit}
          onCancel={() => stopEditingComment()}
          form={`comment-${comment._id}`}
          editedDate={comment.editedDate}
        />
      </CommentFormWrapper>
    );
  };
}

CommentEditForm.propTypes = {
  comment: PropTypes.object.isRequired,
  showMessage: PropTypes.func.isRequired,
  stopEditingComment: PropTypes.func.isRequired,
  updateComment: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  updateComment,
  stopEditingComment,
};

export default _.flowRight(
  connect(
    undefined,
    mapDispatchToProps,
  ),
  withEnvironment({ showMessage: 'showMessage' }),
)(CommentEditForm);
